import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { TEAM_K9_LOGO_URL as LOGO, FALLBACK_LOGO_URL as FALLBACK } from './assets';

// Assets synced from central assets.js
export const TEAM_K9_LOGO_URL = LOGO;
export const FALLBACK_LOGO_URL = FALLBACK;

// SafeIcon Component 
const iconMap = {
  AlertTriangle: FiIcons.FiAlertTriangle,
  Plus: FiIcons.FiPlus,
  Edit: FiIcons.FiEdit,
  Trash2: FiIcons.FiTrash2,
  Calendar: FiIcons.FiCalendar,
  Users: FiIcons.FiUsers,
  User: FiIcons.FiUser,
  LayoutDashboard: FiIcons.FiGrid,
  LogOut: FiIcons.FiLogOut,
  Menu: FiIcons.FiMenu,
  X: FiIcons.FiX,
  MessageCircle: FiIcons.FiMessageCircle,
  Clock: FiIcons.FiClock,
  Check: FiIcons.FiCheck,
  Star: FiIcons.FiStar,
  Video: FiIcons.FiVideo,
  Link: FiIcons.FiLink,
  ExternalLink: FiIcons.FiExternalLink,
  CheckCircle: FiIcons.FiCheckCircle,
  Search: FiIcons.FiSearch,
  ArrowRight: FiIcons.FiArrowRight,
  ChevronLeft: FiIcons.FiChevronLeft,
  ChevronRight: FiIcons.FiChevronRight,
  ChevronUp: FiIcons.FiChevronUp,
  ChevronDown: FiIcons.FiChevronDown,
  List: FiIcons.FiList,
  MessageSquare: FiIcons.FiMessageSquare,
  BarChart2: FiIcons.FiBarChart2,
  CheckSquare: FiIcons.FiCheckSquare,
  Square: FiIcons.FiSquare,
  Code: FiIcons.FiCode,
  Award: FiIcons.FiAward,
  Send: FiIcons.FiSend,
  Info: FiIcons.FiInfo,
  Bold: FiIcons.FiBold,
  Italic: FiIcons.FiItalic,
  Underline: FiIcons.FiUnderline,
  AlignLeft: FiIcons.FiAlignLeft,
  AlignCenter: FiIcons.FiAlignCenter,
  AlignRight: FiIcons.FiAlignRight,
  Book: FiIcons.FiBook
};

export const SafeIcon = ({ icon, name, ...props }) => {
  const IconComponent = icon || iconMap[name] || FiIcons.FiAlertTriangle;
  return <IconComponent {...props} />;
};